// @flow
import ViewDisplay from "./ViewDisplay";

export default ViewDisplay;
